
import UserLogin from "./Login";
import { combineReducers } from "@reduxjs/toolkit";

const AppReducers = combineReducers({
    UserLogin,
});

export { AppReducers, UserLogin };